import BillSwitchBelieveFundingScreen from 'features/billSwitch/screens/BillSwitchBelieveFundingScreen/BillSwitchBelieveFundingScreen';
import React from 'react';

export default function BillSwitchBelieveFundingPage() {
  return <BillSwitchBelieveFundingScreen />;
}
